module.exports = __webpack_public_path__ + "img/index_button.da0508f1.png";